import { combineReducers } from 'redux'
import menusReducer from './menusReducer'

const appReducer = asyncReducers =>
  combineReducers({
    menusData: menusReducer,
    ...asyncReducers,
  })

function rootReducer(asyncReducers) {
  return appReducer(asyncReducers)
}

export default rootReducer
